import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const SearchInputStyles: moduleStyleType = {
    searchIcon: {
        color: 'text.secondary',
        height: '100%',
        position: 'absolute',
        right: '5px',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}
